<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo" @click="goHome">
        <img src="@/assets/img/logo.png">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          class="special"
          v-for="(item,index) in navList"
          :key="index"
          :class="{hover : cut === item.id}"
          @click="navClick(index,item.name)"
          @mouseover="cut = item.id"
        >
          <span class="sb" @click="$router.push(item.path)">
            {{ item.name }}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
          </span>
        </li>
      </ul>
      <Lang class="right-menu-item"></Lang>
      <div v-if="cut === 2" class="tip_product" @mouseleave="cut = 7">
        <div style="display: flex;justify-content: space-evenly">
          <div class="col col--product">
            <div class="uol">
              <div class="built" @click="$router.push('/soft')"><i class="iconfont" style="width: 24px">&#xe627;</i>{{ $t('prod.save') }}</div>
              <ul>
                <li @click="$router.push('/SolidState')">{{ $t('lu.li32') }}</li>
                <ul>
                  <li style="list-style: none" @click="$router.push('/Consumer')">{{ $t('newli.lu1') }}</li>
                  <li style="list-style: none" @click="$router.push('/Enterprise')">{{ $t('newli.lu2') }}</li>
                  <li style="list-style: none" @click="$router.push('/Industrial')">{{ $t('newli.lu3') }}</li>
                  <li style="list-style: none" @click="$router.push('/DataCentersView')">{{ $t('newli.lu4') }}</li>
                </ul>
                <li @click="$router.push('/EmbeddedView')">{{ $t('newli.lu5') }}</li>
                <ul>
                  <li @click="$router.push('/eMMC')" style="list-style: none">eMMC</li>
                  <li @click="$router.push('/UFS')" style="list-style: none">UFS</li>
                </ul>
                <li @click="$router.push('/Frontloaded')">{{ $t('newli.lu6') }}</li>
                <ul>
                  <li @click="$router.push('/ConsumerGrade')" style="list-style: none">{{ $t('newli.lu7') }}</li>
                  <li @click="$router.push('/MemorySticks')" style="list-style: none">{{ $t('newli.lu8') }}</li>
                </ul>
              </ul>
            </div>
            <div class="uol" style="overflow: hidden">
              <div @click="$router.push('/ConsumerElectronics')" class="built" style="margin-bottom: 16px"><i class="iconfont" style="width: 24px;">&#xe627;</i>{{ $t('newli.lu9') }}</div>
              <ul>
                <li @click="$router.push('/ConsumerElectronics')">{{ $t('newli.lu10') }}</li>
                <li @click="$router.push('/ConsumerElectronics')">{{ $t('newli.lu11') }}</li>
                <ul>
                  <li @click="$router.push('/SmartPSSD')" style="list-style: none">{{ $t('newli.lu12') }}</li>
                </ul>
              </ul>
            </div>
            <div class="uol">
              <div class="built" @click="$router.push('/AllFallsh')"><i class="iconfont" style="width: 24px">&#xe63d;</i>{{ $t('newli.lu14') }}</div>
              <ul>
                <li @click="$router.push('/FallshView')">{{ $t('newli.lu16') }}</li>
                <li @click="$router.push('/SpeekTable')">{{ $t('newli.lu17') }}</li>
              </ul>
            </div>
            <!-- SIP 先进封装：由顶部一级导航移入产品中心，作为第四个平行模块 -->
            <div class="uol">
              <div class="built" @click="$router.push('/SIP')"><i class="iconfont" style="width: 24px">&#xe63d;</i>{{ $t('prod.fz') }}</div>
            </div>
          </div>
          <div class="menu">
            <div class="mg">
              <div class="tab_mg">
                <img alt="" src="../../src/assets/img/zl.png">
                <p>{{ $t('xd.bt') }}</p>
              </div>
            </div>
            <div class="button">
              <div class="btn" @click="$router.push('/software')">{{ $t('xd.check') }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="cut === 4" class="tip_product" @mouseleave="cut = 7">
        <div style="display: flex;justify-content: space-between">
          <div class="col">
            <div class="uol">
                <div class="built" @click="$router.push('/PIANO')"><i class="iconfont" style="width: 24px">&#xe640;</i>{{ $t('solution.index')
                  }}
                </div>
                <ul>
                  <li @click="$router.push('/product/Solution/PC')">{{ $t('solution.bl1') }}</li>
                  <li @click="$router.push('/product/Solution/Datacenter')">{{ $t('solution.bl2') }}</li>
                  <li @click="$router.push('/product/Solution/Terminal')">{{ $t('solution.bl3') }}</li>
                  <li @click="$router.push('/product/Solution/CAR')">{{ $t('solution.bl4') }}</li>
                  <li @click="$router.push('/product/Solution/Mobile')">{{ $t('solution.bl5') }}</li>
                  <li @click="$router.push('/product/Solution/Industry')">{{ $t('solution.bl6') }}</li>
                </ul>
            </div>
          </div>
          <div class="menu"
               style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: 100%;">
            <div class="mg">
              <div class="tab_mg">
                <img alt="" src="../../src/assets/img/zl.png">
                <p>{{ $t('solution.zl') }}</p>
              </div>
            </div>
            <div class="button">
              <div class="btn" @click="$router.push('/PIANO')">{{ $t('xd.fa') }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="cut === 5" class="tip_product" @mouseleave="cut = 7">
        <div style="display: flex;justify-content: space-between">
          <div class="col">
            <div class="uol">
                <div class="built" @click="$router.push('/product/Solution')"><i class="iconfont" style="width: 24px">&#xe63f;</i>{{ $t('navbar.about')
                  }}
                </div>
                <ul>
                  <li @click="$router.push('/companyintroduction')">{{ $t('about.bout1') }}</li>
                  <li @click="$router.push('/core')">{{ $t('about.bout3') }}</li>
                  <li @click="$router.push('/Classic')">{{ $t('about.bout4') }}</li>
                  <li @click="$router.push('/news')">{{ $t('about.bout5') }}</li>
                  <li @click="$router.push('/careers')">{{ $t('about.bout7') }}</li>
                </ul>

            </div>
          </div>
          <div class="menu"
               style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: 100%;">
            <div class="mg">
              <div class="tab_mg">
                <img alt="" src="../assets/spec/zl2.png">
                <p>{{ $t('about.tx5') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        <img class="header-img-m"  src="../assets/img/logoyd.png">
        <div
          class="header-nav-m-menu-wrapper"
          @click="menu"
        >
          <div style="border: 1px solid white;display: inline-block">
            <img src="../assets/img/xl.png" style="display: block;width: 27px;height: 32px">
          </div>
        </div>
        <!-- 导航内容 -->
        <div v-if="menuClass === 1" class="nav-content">
          <ul class="header-nav-m-wrapper">
            <li v-for="(item,index) in navList" :key="index" :class="index==navIndex?'active':''" @click="navClick(item)">
              <span style="padding: 0.8rem 0 0.8rem 1rem;">
                {{ item.name }}
              </span>
              <ul class="two"  v-if="er === item.id">
                <li v-for="(ite, inde) in item.children" @click="dsb(ite)" :key="inde">{{ite.name}}</li>
              </ul>
            </li>
          </ul>
          <Lang class="right-menu-item"></Lang>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import router from "../router";
import Lang from "./Lang/index.vue";
export default {
  name: "Header",
  components: {Lang},
  computed:{
    navList(){
      return[
        // 社会责任：暂不展示，代码保留
        // {
        //   id:1,
        //   name: this.$t('navbar.duty'),
        //   path: "/service",
        //   children: []
        // },
        {
          id:1,
          name: this.$t('navbar.index'),
          path: "/",
          children: []
        },
        {
          id:2,
          name: this.$t('navbar.center'),
          path: null,
          children: [
            {
              name:this.$t('prod.save'),
              route: '/soft'
            },
            {
              name:this.$t('prod.dd'),
              route: '/store'
            },
            {
              name:this.$t('prod.fz'),
              route: '/GENRE'

            },
          ]
        },
        {
          id:4,
          name: this.$t('navbar.solve'),
          path: null,
          children: [
            {
              name:this.$t('solution.bl1'),
              route: '/product/Solution/PC'
            },
            {
              name:this.$t('solution.bl2'),
              route: '/product/Solution/Datacenter'
            },
            {
              name:this.$t('solution.bl3'),
              route: '/product/Solution/Terminal'
            },
            {
              name:this.$t('solution.bl4'),
              route: '/product/Solution/CAR'
            },
            {
              name:this.$t('solution.bl5'),
              route: '/product/Solution/Mobile'
            },
            {
              name:this.$t('solution.bl6'),
              route: '/product/Solution/Industry'
            },
          ]
        },
        {
          id:5,
          name: this.$t('navbar.about'),
          path: null,
          children: [
            {
              name:this.$t('about.bout1'),
              route: '/companyintroduction'
            },
            {
              name:this.$t('about.bout3'),
              route: '/core'
            },
            {
              name:this.$t('about.bout4'),
              route: '/Classic'
            },
            {
              name:this.$t('about.bout5'),
              route: '/news'
            },
            {
              name:this.$t('about.bout7'),
              route: '/careers'
            },
          ]
        },
        {
          id:6,
          name: this.$t('about.bout8'),
          path: "/contactus",
          children: []
        },
      ]
    }
  },
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: 0,
      cut:0,
      er:0,
    };
  },
  methods: {
    router() {
      return router
    },
    goHome(){
      this.menuClass = 0;
      this.$router.push('/')
    },
    dsb(ite){
      this.menuClass = 0;
      this.$router.push(ite.route)
    },
    navClick(item) {
      if (item.path != null){
        this.menuClass = 0;
        this.$router.push(item.path);
      }else {
        if (this.er !== 0){
          this.er = 0;
        }else {
          this.er = item.id;
        }
      }
    },
    menu() {
      if (this.menuClass === 0) {
        this.menuClass = 1;
      } else {
        this.menuClass = 0;
        this.er = 0;
      }
    },
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: black;
  transition: all ease 0.6s;
}

#header .header-top {
  height: 60px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav {
  height: 60px;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 130px;
  height: 100%;
  float: left;
  position: relative;
  cursor: pointer;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 130px;
  height: 30px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 60px;
}

#header .header-nav .header-nav-wrapper {
  display: inline-block;
  line-height: 60px;
  margin-left: 8px;
  margin-bottom: 0 !important;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  padding: 0 15px;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > .sb {
  display: inline-block;
  height: 60px;
  line-height: 60px;
  color: white;
  font-size: 15px;
  font-weight: bold;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > .sb > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > .sb:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  text-decoration: none;
}
#header .header-nav .special:hover{
  cursor: pointer;
}
/* 所有一级导航鼠标悬停：统一显示左右白色竖线 + 深色底 */
#header .header-nav .special.hover{
  background: #222222 !important;
  border-right: 1px solid white;
  border-left: 1px solid white;
}
/* 所有一级导航悬停时小三角翻转 */
#header .header-nav .special.hover .sb > span{
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
#header .right-menu-item {
  cursor: pointer ;
  float: right;
  height: 60px;
  line-height: 60px;
}
#header .tip_product {
  max-width: 1170px;
  display: inline-table;
  position: absolute;
  z-index: 9999;
  border-left: 1px solid white;
  border-bottom: 1px solid white;
  border-right: 1px solid white;
  background: #222222;
  padding: 1.5rem !important;
  margin: 0 auto;
  top: 60px;
  bottom: 0;
  right: 0;
  left: 0;
}

#header .tip_product .col {
  display: flex;
  flex-wrap: wrap;
  width: 890px;
  border-right: 1px solid white;
}

#header .tip_product .col .uol {
  margin-right: 60px;
}

/* 产品中心：四列平分原来固定 890px 的宽度，英文标题也塞得下四列；其余弹窗不受影响 */
#header .tip_product .col--product {
  justify-content: space-between;
}

#header .tip_product .col--product .uol {
  margin-right: 0;
}

/* 最后一列跟右侧竖线留一点缝，不贴线 */
#header .tip_product .col--product .uol:last-child {
  margin-right: 20px;
}

#header .tip_product .col .uol .built {
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
  color: #D1DFFF;
  line-height: 22px;
  margin-bottom: 21px;
}

#header .tip_product .col .uol .built i {
  padding: 0 4px;
}

#header .tip_product .col ul {
  list-style: disc !important;
  padding-left: 25px;
  display: flex;
  flex-direction: column;
  width: 180px;
}

#header .tip_product .col ul li {
  padding-left: 6px;
  cursor: pointer;
  line-height: 28px;
  border-bottom: 1px solid #D8D8D8;
  color: white;
  margin-bottom: 16px;
}

#header .tip_product .col ul li:hover {
  background: white;
  list-style: none;
  color: black;
}

#header .tip_product .menu {
  display: inline-block;
}

#header .tip_product .menu .tab_mg {
  text-align: center;
  color: white;
}

#header .tip_product .menu .tab_mg p {
  margin-top: 20px;
}

#header .tip_product .menu .button {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

#header .tip_product .menu .button .btn {
  padding: 8px 1.5rem;
  border: 1px solid white;
}

#header .tip_product .menu .button .btn:hover {
  background: white;
  color: black;
  cursor: pointer;
}


@media screen and (max-width: 1170px){
  #header .col{
    width: auto !important;
  }
}

@media screen and (max-width: 1014px){
  #header .right-menu-item{
    display: none !important;
  }
  #header .header-nav .header-nav-logo{
    width: 120px !important;
  }
  .col{
    width: auto !important;
  }
}

@media screen and (max-width: 768px) {
  #header .right-menu-item{
    display: block !important;
    margin: 0 auto;
    float: none;
  }
  #header .header-img-m {
    display: flex;
    margin: 0 auto;
    height: 100%;
  }

  #header .nav-content {
    position: fixed;
    z-index: 99998;
    padding-top: 20px;
    background: black;
    width: 100%;
    height: 100vh;
  }

  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: black;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 99998;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: relative;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    text-align: left;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }

  #header .two li{
    color: black;
    padding: 0.8rem 1rem;
    background: white;
    border-bottom: 1px #ddd solid;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue